
export const formatTime = (time: string): string => {
  const match = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(time.trim());
  if (!match) throw new Error('Time must be in the format hh:mm or hh:mm:ss');
  let hours = Number(match[1]);
  const minutes = match[2];
  const period = hours >= 12 ? 'PM' : 'AM';
  hours %= 12;
  if (hours === 0) hours = 12;
  return `${hours}:${minutes} ${period}`;
};

export const formatTimeRange = (
  start?: string,
  end?: string,
  separator = '–',
): string => {
  const label = (value?: string): string => {
    if (!value) return '';
    try {
      return formatTime(value);
    } catch {
      return value;
    }
  };
  if (!start) return '';
  return [label(start), label(end)].filter(Boolean).join(` ${separator} `);
};
